import React, { Component } from "react";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import Routes from "./Routes";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
//Toast Notification imports
import ReactNotification from "react-notifications-component";
import ReactGA from "react-ga";
import { googleAnalyticsID, googleApiKey } from "./bl_libs/ApiCalling";
import { SnackbarProvider } from "notistack";

const browserHistory = createBrowserHistory();

// load Google map script
const script = document.createElement("script");

script.src = `https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&libraries=places`;
script.async = true;

document.body.appendChild(script);

export default class App extends Component {
  constructor(props) {
    super(props);
    if (process.env.REACT_APP_ENV === "production") {
      console.log = () => {};
      console.disableYellowBox = true;
    }
  }
  render() {
    const theme = createMuiTheme({
      palette: {
        primary: {
          // primary color
          main: "#C4314B",
        },
      },
    });

    ReactGA.initialize(googleAnalyticsID);
    browserHistory.listen(() => {
      ReactGA.pageview(window.location.pathname + window.location.search);
    });
    return (
      <SnackbarProvider maxSnack={3}>
        <ThemeProvider theme={theme}>
          <ReactNotification />
          <Router history={browserHistory}>
            <Routes />
          </Router>
        </ThemeProvider>
      </SnackbarProvider>
    );
  }
}
